/**
 * Sync mirror of server `forfeited` so guided UI can stay hidden on refresh
 * before `/onboarding/status` resolves (avoids banner / hub flash).
 */
const STORAGE_KEY = 'onboarding-forfeited'

export function readOnboardingForfeitCache(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function writeOnboardingForfeitCache(forfeited: boolean): void {
  try {
    if (forfeited) {
      localStorage.setItem(STORAGE_KEY, '1')
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // ignore quota / private mode
  }
}

export function syncOnboardingForfeitCache(status: { forfeited: boolean }): void {
  writeOnboardingForfeitCache(status.forfeited)
}

/** Prefer server when loaded; otherwise sync cache from last known forfeit. */
export function isOnboardingForfeited(
  status?: { forfeited?: boolean } | null,
): boolean {
  if (status?.forfeited === true) return true
  if (status?.forfeited === false) return false
  return readOnboardingForfeitCache()
}
